module.exports = __webpack_public_path__ + "static/media/sat.d156ad85.JPG";